/**
 * Управление z-index для стекирования модальных окон.
 */

/**
 * Обновляет z-index всех модальных окон и канвасов.
 * Вызывается как статический метод: ModalManager.updateAllModalsZIndex()
 * @param {typeof import('../ModalManager').ModalManager} ModalManagerClass
 */
export function updateAllModalsZIndex(ModalManagerClass) {
    requestAnimationFrame(() => {
        const modals = Array.from(document.querySelectorAll('.modal.fade'));
        const canvases = Array.from(document.querySelectorAll('.offcanvas'));
        const backdrops = Array.from(document.querySelectorAll('.modal-backdrop.fade, .offcanvas-backdrop.fade'));

        const allElements = [...modals, ...canvases];

        if (allElements.length > 0) {
            allElements.forEach((element, index) => {
                const zIndexModal = ModalManagerClass.BASE_MODAL_Z_INDEX + ModalManagerClass.Z_INDEX_INCREMENT * index;
                const zIndexBackdrop = ModalManagerClass.BASE_BACKDROP_Z_INDEX + ModalManagerClass.Z_INDEX_INCREMENT * index;

                element.style.zIndex = zIndexModal.toString();

                if (backdrops[index]) {
                    backdrops[index].style.zIndex = zIndexBackdrop.toString();
                }
            });
        }
    });
}
